import React from 'react'
import CountUp from "react-countup";
import { useInView } from "react-intersection-observer";
const RightPage3 = () => {
    const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.5,
  });
  return (
    <div className='mt-20'>
      <div ref={ref} className="flex flex-wrap justify-center gap-36 py-12">
      <div className="text-center">
        <div className="text-5xl text-blue-600 mb-2">
          😊
        </div>
        <div className="text-4xl font-bold">
          {inView && <CountUp end={232} duration={2} />}
        </div>
        <h3 className="text-lg font-semibold">Happy Clients</h3>
        <p className="text-gray-500">Clients we serve

</p>
      </div>

      <div className="text-center">
        <div className="text-5xl text-blue-600 mb-2">
          📝
        </div>
        <div className="text-4xl font-bold">
          {inView && <CountUp end={521} duration={2} />}
        </div>
        <h3 className="text-lg font-semibold">Projects</h3>
        <p className="text-gray-500">Completed</p>
      </div>

      <div className="text-center">
        <div className="text-5xl text-blue-600 mb-2">
          🎧
        </div>
        <div className="text-4xl font-bold">
          {inView && <CountUp end={1453} duration={2} />}
        </div>
        <h3 className="text-lg font-semibold">Hours Of Support</h3>
        <p className="text-gray-500">Always here to help</p>
      </div>

      <div className="text-center">
        <div className="text-5xl text-blue-600 mb-2">
          👥
        </div>
        <div className="text-4xl font-bold">
          {inView && <CountUp end={32} duration={2} />}
        </div>
        <h3 className="text-lg font-semibold">Hard Workers</h3>
        <p className="text-gray-500">Team that delivers</p>
      </div>
    </div>
    </div>
  )
}

export default RightPage3
